export default function ({children}) {
    const fontFamily = window.location.pathname.includes('/app/report') ? 'Calibri' : 'Segoe UI'
    const fontSize = window.location.pathname.includes('/app/report') ? '11pt' : '9pt'

    return (
        <div style={{ fontSize: fontSize, fontFamily: fontFamily }}>
            {children}
        </div>
    );
}